var map = {
	"./banco_do_brasil.png": "./src/assets/banks/banco_do_brasil.png",
	"./bradesco.png": "./src/assets/banks/bradesco.png",
	"./itau.png": "./src/assets/banks/itau.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/banks sync recursive ^\\.\\/.*\\.png$";